import { useState } from 'react';

/**
 * Custom hook for managing assign root admin modal state in AdminDashboard
 * 
 * @returns {Object} Object containing modal state and setters
 */
export const useAssignRootAdminModalState = () => {
    // Assign Root Admin modal states
    const [isAssignRootAdminOpen, setIsAssignRootAdminOpen] = useState(false);
    const [assignRootAdminOrganization, setAssignRootAdminOrganization] = useState(null);
    const [assignRootAdminUserId, setAssignRootAdminUserId] = useState('');
    const [assignRootAdminSearch, setAssignRootAdminSearch] = useState('');
    const [isAssignRootAdminDropdownOpen, setIsAssignRootAdminDropdownOpen] = useState(false);
    const [assignRootAdminError, setAssignRootAdminError] = useState('');
    const [assignRootAdminSaving, setAssignRootAdminSaving] = useState(false);

    return {
        isAssignRootAdminOpen,
        setIsAssignRootAdminOpen,
        assignRootAdminOrganization,
        setAssignRootAdminOrganization,
        assignRootAdminUserId,
        setAssignRootAdminUserId,
        assignRootAdminSearch,
        setAssignRootAdminSearch,
        isAssignRootAdminDropdownOpen,
        setIsAssignRootAdminDropdownOpen,
        assignRootAdminError,
        setAssignRootAdminError,
        assignRootAdminSaving,
        setAssignRootAdminSaving
    };
};
